import { ChangeDetectionStrategy, Component, CUSTOM_ELEMENTS_SCHEMA, inject } from '@angular/core';
import { Router, RouterOutlet } from '@angular/router';

@Component({
  selector: 'app-sales-page',
  imports: [RouterOutlet],
  templateUrl: './sales-page.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class SalesPageComponent {
  private readonly router = inject(Router);

  protected openCloserDocumentTool(): void {
    void this.router.navigate(['/sales/closer-document']);
  }
}
